<template>
  <div class="tabs">
    <p class="h3">{{ title }}</p>
    <slot />
  </div>
</template>

<script>
export default {
  name: 'TabsHeader',
  props: {
    title: String,
  },
};
</script>

<style lang="less" scoped>
@import '~@/assets/style/mixins.less';
@import '~@/assets/style/var.less';
.tabs {
  color: @font-color-black;
  padding-top: 15px;
  .reconciliation_list_space(@bg-white);
  .h3 {
    font-size: 20px;
    margin-top: 0;
    margin-bottom: 20px;
    font-weight: 500;
  }
}
</style>
